module.exports = __webpack_public_path__ + "static/media/Krishan.7c56eb18.jpg";